/**
 * Entry Point – Dual Mode Bootstrap
 *
 * This file is the single entry point produced by the CRA build.
 * At load time it detects which mode to run in:
 *
 *   1. WIDGET MODE  – if a #tax-calculator element exists in the DOM.
 *      Renders only the questionnaire flow inside that container.
 *      Config is read from data-* attributes on the container.
 *      Skips the full router/app shell.
 *
 *   2. STANDALONE MODE – otherwise, renders the full application
 *      into #root (the default CRA behaviour).
 *
 * In both modes the bundle also registers window.TaxCalculator so the
 * host page (or dev console) can call mount/unmount imperatively.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { mountWidget, registerGlobalApi } from './widget/mount';

// Always register the global API so the host can call TaxCalculator.mount()
// even if #tax-calculator does not exist yet (deferred / SPA host).
registerGlobalApi();

const widgetContainer = document.getElementById('tax-calculator');
const autoMount = widgetContainer?.dataset.autoMount !== 'false';

if (widgetContainer && autoMount) {
  // ── Widget mode ──────────────────────────────────────────────────────
  mountWidget(widgetContainer);
} else if (!widgetContainer) {
  // ── Standalone mode ──────────────────────────────────────────────────
  const rootEl = document.getElementById('root');
  if (rootEl) {
    const root = ReactDOM.createRoot(rootEl);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  }
}
